// src/services/doubtService.ts
import apiClient from "../api/apiClient";

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? "1";

export interface DoubtUser {
    id: number;
    displayName: string;
    email: string;
    profilePhotoUrl?: string | null;
    school?: string;
    medium?: string;
    className?: string;
    mobile?: string;
    district?: string;
}

export interface Doubt {
    id: number;
    question: string;
    answer?: string | null;
    status: "OPEN" | "ANSWERED";
    createdAt: string; // ISO date string
    subjectId: number;
    user: DoubtUser;
    questionMedia: string[]; // e.g. ["/uploads/doubts/...jpg", ...]
    answerMedia: string[];
}

export interface GetDoubtsParams {
    subjectId?: number;
    answered?: boolean; // true for ANSWERED, false for OPEN, undefined for ALL
    page?: number;
    size?: number;
}

// Helper to construct full image URL since the API returns relative paths
export const getFullUrl = (path: string | undefined | null) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    // Attempt to get base URL from env, similar to apiClient but accessible here
    const rawApiUrl = process.env.REACT_APP_API_URL ?? "https://vidyasamruddhi.co.in";
    // Remove trailing slash from base and leading slash from path to avoid double slashes
    const baseUrl = rawApiUrl.replace(/\/+$/, "");
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${baseUrl}${cleanPath}`;
};

export async function getDoubts(params: GetDoubtsParams) {
    // GET /api/admin/doubts
    const resp = await apiClient.get("/admin/doubts", {
        params: {
            ...params,
            tenantId: TENANT_ID,
        },
    });
    return resp.data;
}

export async function answerDoubt(doubtId: number, answerText: string, file?: File | null) {
    // POST /api/doubts/:doubtId/answer
    const formData = new FormData();

    // The API expects a "data" part with JSON string for the answer text
    formData.append("data", JSON.stringify({ answer: answerText }));

    // The API expects a "files" part for attachments (Zip or individual files)
    if (file) {
        formData.append("files", file);
    }

    const resp = await apiClient.post(`/doubts/${doubtId}/answer`, formData, {
        params: { tenantId: TENANT_ID },
        headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data;
}